var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 52,
    viewBox: "0 0 58 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.62109 0.799999H52.3789C55.3743 0.799999 57.8 3.28309 57.8 6.34742V42.1977V42.1999V45.6526C57.8 48.7169 55.3743 51.2 52.3789 51.2H5.62109C2.62697 51.2 0.200012 48.7165 0.200012 45.6526V36.439V36.4388V6.34742C0.200012 3.28351 2.62697 0.799999 5.62109 0.799999ZM53.6261 6.34742V37.1991L43.5738 26.6755L43.4163 26.5277C42.5376 25.7878 41.0637 25.8243 40.2444 26.6476L33.3123 33.6118L19.4873 19.4602L19.3281 19.314C18.4409 18.583 16.9698 18.6317 16.1605 19.4602L4.37393 31.525V6.34742C4.37393 5.64242 4.93215 5.07119 5.62109 5.07119H52.3789C53.0688 5.07119 53.6261 5.64167 53.6261 6.34742ZM4.37393 45.6526V37.2101L17.8239 23.4425L31.6351 37.5798L31.8037 37.7337C32.6866 38.4522 34.1393 38.4066 34.9496 37.5923L41.8611 30.6454L53.6261 42.9618V45.6526C53.6261 46.3583 53.0688 46.9288 52.3789 46.9288H5.62109C4.93215 46.9288 4.37393 46.3576 4.37393 45.6526ZM43.4 18.8C45.3872 18.8 47 17.1872 47 15.2C47 13.2128 45.3872 11.6 43.4 11.6C41.4128 11.6 39.8 13.2128 39.8 15.2C39.8 17.1872 41.4128 18.8 43.4 18.8Z",
    fill: "#B8BECC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoImage);
export default __webpack_public_path__ + "static/media/no-image.3f411072a36d94c840a7c90b26272886.svg";
export { ForwardRef as ReactComponent };